module.exports = __webpack_public_path__ + "img/ring_r_i_1_0.4088d8f0.png";